import baseObject from '../../../utilities/data/mediaTapperBaseObj.js';
import { chartObject } from '../../../utilities/data/mediaTapperBaseObj.js';

const RPDChartData = {
	"music": "https://media.frame.media/pact-datascroll/259283__klankbeeld__city-traffic-02-ms-141121-0457.mp3",
	"slides": [
		{
			"url": "https://media.frame.media/pact-datascroll-2/police_wide.jpg",
			"mobileUrl": "https://media.frame.media/pact-datascroll-2/police.jpg",
			"textbox": {
				"text": "Raleigh PD’s apparent racial bias can be understood through the experiences of the families they police, but it can also be seen in the data.",
				"placement": {
					"x": null,
					"y": "40vh",
					"absolute": true
				}
			},
			"chart": {
				"text": ""
			}
		},
		{
			"url": "https://media.frame.media/pact-datascroll-2/rain_wide.jpg",
			"mobileUrl": "https://media.frame.media/pact-datascroll-2/rain.jpg",
			"chart": {
				"elType": baseObject.chart,
				"chartType": chartObject.circleBar,
				"offset": {
					"left": 20,
					"top": 100
				},
				"csvKey": "census",
				"text": {
					"header": "The city is majority white."
				}
			},
		},
		{
			"url": "https://media.frame.media/pact-datascroll-2/faces_wide.jpg",
			"mobileUrl": "https://media.frame.media/pact-datascroll-2/faces.jpg",
			"chart": {
				"elType": baseObject.chart,
				"chartType": chartObject.lines,
				"csvKey": "searchRate",
				"text": {
					"header": "But its attention is unequally fixed on policing Black communities.",
				}
			},
		},
		{
			"url": "https://media.frame.media/pact-datascroll-2/protest_wide.jpg",
			"mobileUrl": "https://media.frame.media/pact-datascroll-2/protest.jpg",
			"chart": {
				"elType": baseObject.chart,
				"chartType": chartObject.circleBar,
				"offset": {
					"left": 20,
					"top": 10
				},
				"csvKey": "hitrate",
				"text": {
					"header": "Though Black people are searched more frequently, contraband is found at similar rates across Raleigh.",
				},
			}
		},
		{
			"url": "https://media.frame.media/pact-datascroll-2/candle_wide.jpg",
			"mobileUrl": "https://media.frame.media/pact-datascroll-2/candle.jpg",
			"chart": {
				"elType": baseObject.chart,
				"chartType": chartObject.bar,
				"csvKey": "force",
				"text": {
					"header": "The difference in the use of force is even more dramatic.",
				}
			},
		},
		{
			"url": "https://media.frame.media/pact-datascroll-2/dc_wide.jpg",
			"mobileUrl": "https://media.frame.media/pact-datascroll-2/dc.jpg",
			"textbox": {
				"text": "These trends are similar nationwide. In 2019, the percentage of Black people who experienced threats or the use of force during police interactions was double that of white people.",
				"placement": {
					"x": null,
					"y": "40vh",
					"absolute": true
				}
			},
			"chart": {
				"text": {
					"header": ""
				}
			}
		},
	],
};

export const colorReference = {
	"Black": {
		chartColor: "#6f1a96",
	},
	"White": {
		chartColor: "#0ead42",
	},
	"Hispanic": {
		chartColor: "orange",
	},
	"Asian": {
		chartColor: "#2abfba",
	},
	"Other": {
		chartColor: "#961a3b",
	},
	"Native American": {
		chartColor: "#ff91f8",
	},
}

export default RPDChartData;